import { SET_SECTIONS, SET_CONTRIBUTOR } from '../actions/actionTypes'

const initialState = {
    sections: null,
    sharepoint_files: [
        {
            name: "Research Memo",
            label: "Research Memo",
            id: 'rm'
        },
        {
            name: "Meeting Note",
            label: "Meeting Note & Mission Report",
            id: 'mn'
        },
        {
            name: "Contribution Agreement",
            label: "Contribution Agreement (incl. Amendments & Side Letters)",
            id: 'ca'
        },
        {
            name: "Encashment Schedule",
            label: "Encashment Schedule",
            id: 'es'
        },
        {
            name: "Email",
            label: "Emails",
            id: 'em'
        }
    ],
    contributor: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SECTIONS:
            return { ...state, sections: action.sections }
        case SET_CONTRIBUTOR:
            return { ...state, contributor: action.data }
        default:
            return state
    }
}

export default reducer